// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
// } from "recharts";
// import LimitsWidget from "./LimitsWidget";

// const API_URL = process.env.REACT_APP_API_BASE_URL;

// export default function Dashboard() {
//   const [loading, setLoading] = useState(true);
//   const [subscriptionError, setSubscriptionError] = useState(null);
//   const [stats, setStats] = useState({
//     totalCampaigns: 0, totalSent: 0, totalFailed: 0, totalContacts: 0,
//     activeCampaigns: 0, completedCampaigns: 0, pausedCampaigns: 0, stoppedCampaigns: 0,
//     todaySent: 0, todayFailed: 0, totalMessages: 0, messagesToday: 0,
//     incomingMessages: 0, outgoingMessages: 0,
//     recentCampaigns: [], dailyStats: [], campaignStatusData: [], smtpPerformance: [],
//   });

//   const navigate = useNavigate();
//   const COLORS = ['#22c55e', '#eab308', '#3b82f6', '#ef4444'];

//   useEffect(() => {
//     async function loadDashboard() {
//       try {
//         setLoading(true);
//         setSubscriptionError(null);

//         const res = await axios.get(`${API_URL}/api/dashboard`);
//         const data = res.data;

//         const campaignStatusData = [
//           { name: "Активные", value: data.campaigns.active, color: "#22c55e" },
//           { name: "На паузе", value: data.campaigns.paused, color: "#eab308" },
//           { name: "Завершены", value: data.campaigns.completed, color: "#3b82f6" },
//           { name: "Остановлены", value: data.campaigns.stopped, color: "#ef4444" },
//         ].filter(item => item.value > 0);

//         const smtpPerformance = data.smtp_performance.map(s => ({
//           ...s,
//           received: Math.floor(Math.random() * 10) + 1,
//         }));

//         setStats({
//           totalCampaigns: data.campaigns.total,
//           totalSent: data.campaigns.total_sent,
//           totalFailed: data.campaigns.total_failed,
//           totalContacts: data.contacts.total,
//           activeCampaigns: data.campaigns.active,
//           completedCampaigns: data.campaigns.completed,
//           pausedCampaigns: data.campaigns.paused,
//           stoppedCampaigns: data.campaigns.stopped,
//           todaySent: data.today.sent,
//           todayFailed: data.today.failed,
//           totalMessages: data.messages.total,
//           messagesToday: data.messages.today,
//           incomingMessages: data.messages.incoming,
//           outgoingMessages: data.messages.outgoing,
//           recentCampaigns: data.recent_campaigns || [],
//           dailyStats: data.daily_stats || [],
//           campaignStatusData,
//           smtpPerformance,
//         });

//       } catch (err) {
//         console.error("Ошибка загрузки дашборда:", err);

//         if (err.response?.status === 403) {
//           setSubscriptionError({
//             message: err.response.data?.message || "Дашборд доступен только на тарифе Premium"
//           });
//         } else if (err.response?.status === 401) {
//           navigate('/login');
//         } else {
//           setSubscriptionError({
//             message: "Не удалось загрузить данные. Попробуйте позже."
//           });
//         }
//       } finally {
//         setLoading(false);
//       }
//     }

//     loadDashboard();
//   }, [navigate]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
//       </div>
//     );
//   }

//   // ===== ЗАГЛУШКА «НУЖНА ПОДПИСКА» =====
//   if (subscriptionError) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 md:p-6">
//         <div className="bg-white rounded-2xl shadow-md p-6 md:p-10 max-w-lg w-full text-center">
//           <div className="text-5xl md:text-6xl mb-4">🔒</div>
//           <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
//             Дашборд доступен на платных тарифах
//           </h1>
//           <p className="text-gray-500 mb-6 text-sm md:text-base">
//             {subscriptionError.message}
//           </p>

//           <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-left">
//             <div className="text-sm text-blue-900 font-medium mb-2">
//               Что даёт подписка:
//             </div>
//             <ul className="text-sm text-blue-800 space-y-1">
//               <li>✓ Полная статистика по кампаниям</li>
//               <li>✓ Графики отправок по дням</li>
//               <li>✓ Аналитика по SMTP-аккаунтам</li>
//               <li>✓ Статистика переписок</li>
//             </ul>
//           </div>

//           <button
//             onClick={() => navigate('/pricing')}
//             className="w-full px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition font-medium"
//           >
//             Перейти к тарифам →
//           </button>

//           <button
//             onClick={() => navigate('/smtp')}
//             className="w-full mt-3 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition"
//           >
//             Вернуться к работе
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-6">
//       {/* ===== ЗАГОЛОВОК ===== */}
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4 md:mb-6">
//         <div>
//           <h1 className="text-xl md:text-3xl font-bold text-gray-800">📊 Дашборд</h1>
//           <p className="text-gray-500 mt-1 text-xs md:text-sm">Общая статистика по кампаниям</p>
//         </div>
//         <div className="flex items-center gap-2 flex-wrap">
//           <span className="text-xs md:text-sm text-gray-500">
//             Обновлено: {new Date().toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
//           </span>
//           <button
//             onClick={() => window.location.reload()}
//             className="px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
//           >
//             🔄
//           </button>
//         </div>
//       </div>

//       {/* ===== ЛИМИТЫ ===== */}
//       <LimitsWidget />

//       {/* ===== ВЕРХНИЕ КАРТОЧКИ ===== */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6">
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-blue-500">
//           <div className="text-xs md:text-sm text-gray-500">Кампаний</div>
//           <div className="text-2xl md:text-3xl font-bold text-gray-800">{stats.totalCampaigns}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Активных: {stats.activeCampaigns}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-green-500">
//           <div className="text-xs md:text-sm text-gray-500">Отправлено</div>
//           <div className="text-2xl md:text-3xl font-bold text-green-600">{stats.totalSent}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Сегодня: {stats.todaySent}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-yellow-500">
//           <div className="text-xs md:text-sm text-gray-500">Контактов</div>
//           <div className="text-2xl md:text-3xl font-bold text-yellow-600">{stats.totalContacts}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Ошибок: {stats.totalFailed}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-purple-500">
//           <div className="text-xs md:text-sm text-gray-500">Сообщений</div>
//           <div className="text-2xl md:text-3xl font-bold text-purple-600">{stats.totalMessages}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Сегодня: {stats.messagesToday}
//           </div>
//         </div>
//       </div>

//       {/* ===== ГРАФИКИ ===== */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
//         {/* График отправок */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📈 Отправки по дням</h2>
//           <div className="h-48 md:h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={stats.dailyStats} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="date" tick={{ fontSize: 10 }} />
//                 <YAxis tick={{ fontSize: 10 }} />
//                 <Tooltip contentStyle={{ fontSize: 12 }} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Line type="monotone" dataKey="sent" stroke="#22c55e" name="Отправлено" strokeWidth={2} dot={{ r: 2 }} />
//                 <Line type="monotone" dataKey="failed" stroke="#ef4444" name="Ошибок" strokeWidth={2} dot={{ r: 2 }} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Круговая диаграмма */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📊 Статусы кампаний</h2>
//           <div className="h-48 md:h-64 flex items-center justify-center">
//             {stats.campaignStatusData.length > 0 ? (
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={stats.campaignStatusData}
//                     cx="50%"
//                     cy="50%"
//                     innerRadius={40}
//                     outerRadius={70}
//                     paddingAngle={2}
//                     dataKey="value"
//                     label={({ value }) => value}
//                     labelLine={false}
//                   >
//                     {stats.campaignStatusData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={entry.color} />
//                     ))}
//                   </Pie>
//                   <Tooltip contentStyle={{ fontSize: 12 }} />
//                   <Legend wrapperStyle={{ fontSize: 11 }} />
//                 </PieChart>
//               </ResponsiveContainer>
//             ) : (
//               <div className="text-gray-400 text-sm">Нет данных о кампаниях</div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ===== АКТИВНОСТЬ SMTP + ПОСЛЕДНИЕ ===== */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📧 Активность SMTP</h2>
//           <div className="h-48 md:h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={stats.smtpPerformance} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" tick={{ fontSize: 10 }} />
//                 <YAxis tick={{ fontSize: 10 }} />
//                 <Tooltip contentStyle={{ fontSize: 12 }} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Bar dataKey="sent" fill="#22c55e" name="Отправлено" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* ===== ПОСЛЕДНИЕ КАМПАНИИ ===== */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">🔄 Последние кампании</h2>
//           <div className="space-y-2 max-h-56 md:max-h-64 overflow-y-auto">
//             {stats.recentCampaigns.length > 0 ? (
//               stats.recentCampaigns.map((item) => (
//                 <div key={item.id} className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition">
//                   <div className="min-w-0 flex-1">
//                     <div className="font-medium text-gray-800 text-sm truncate">{item.name}</div>
//                     <div className="text-xs text-gray-400">
//                       {new Date(item.created_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
//                     </div>
//                   </div>
//                   <div className="flex items-center gap-2 flex-wrap">
//                     <span className="text-xs md:text-sm text-gray-600">
//                       {item.sent}/{item.total}
//                     </span>
//                     <span className={`px-2 py-0.5 text-[10px] md:text-xs rounded-full whitespace-nowrap ${
//                       item.status === "running" ? "bg-green-100 text-green-700" :
//                       item.status === "completed" ? "bg-blue-100 text-blue-700" :
//                       item.status === "paused" ? "bg-yellow-100 text-yellow-700" :
//                       "bg-red-100 text-red-700"
//                     }`}>
//                       {item.status === "running" ? "▶️ Выполняется" :
//                        item.status === "completed" ? "✅ Завершена" :
//                        item.status === "paused" ? "⏸️ На паузе" :
//                        "⏹️ Остановлена"}
//                     </span>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="text-gray-400 text-center py-8 text-sm">Нет кампаний</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
// } from "recharts";
// import LimitsWidget from "./LimitsWidget";

// const API_URL = process.env.REACT_APP_API_BASE_URL;

// export default function Dashboard() {
//   const [loading, setLoading] = useState(true);
//   const [subscriptionError, setSubscriptionError] = useState(null);
//   const [stats, setStats] = useState({
//     totalCampaigns: 0, totalSent: 0, totalFailed: 0, totalContacts: 0,
//     activeCampaigns: 0, completedCampaigns: 0, pausedCampaigns: 0, stoppedCampaigns: 0,
//     todaySent: 0, todayFailed: 0, totalMessages: 0, messagesToday: 0,
//     incomingMessages: 0, outgoingMessages: 0,
//     recentCampaigns: [], dailyStats: [], campaignStatusData: [], smtpPerformance: [],
//     tracking: { opened: 0, clicked: 0, total_opens: 0, total_clicks: 0, open_rate: 0, opened_today: 0 },
//     top_campaigns: [],
//   });

//   const navigate = useNavigate();
//   const COLORS = ['#22c55e', '#eab308', '#3b82f6', '#ef4444'];

//   useEffect(() => {
//     async function loadDashboard() {
//       try {
//         setLoading(true);
//         setSubscriptionError(null);

//         const res = await axios.get(`${API_URL}/api/dashboard`);
//         const data = res.data;

//         const campaignStatusData = [
//           { name: "Активные", value: data.campaigns.active, color: "#22c55e" },
//           { name: "На паузе", value: data.campaigns.paused, color: "#eab308" },
//           { name: "Завершены", value: data.campaigns.completed, color: "#3b82f6" },
//           { name: "Остановлены", value: data.campaigns.stopped, color: "#ef4444" },
//         ].filter(item => item.value > 0);

//         const smtpPerformance = data.smtp_performance.map(s => ({
//           ...s,
//           received: Math.floor(Math.random() * 10) + 1,
//         }));

//         setStats({
//           totalCampaigns: data.campaigns.total,
//           totalSent: data.campaigns.total_sent,
//           totalFailed: data.campaigns.total_failed,
//           totalContacts: data.contacts.total,
//           activeCampaigns: data.campaigns.active,
//           completedCampaigns: data.campaigns.completed,
//           pausedCampaigns: data.campaigns.paused,
//           stoppedCampaigns: data.campaigns.stopped,
//           todaySent: data.today.sent,
//           todayFailed: data.today.failed,
//           totalMessages: data.messages.total,
//           messagesToday: data.messages.today,
//           incomingMessages: data.messages.incoming,
//           outgoingMessages: data.messages.outgoing,
//           recentCampaigns: data.recent_campaigns || [],
//           dailyStats: data.daily_stats || [],
//           campaignStatusData,
//           smtpPerformance,
//           tracking: data.tracking || { opened: 0, clicked: 0, total_opens: 0, total_clicks: 0, open_rate: 0, opened_today: 0 },
//           top_campaigns: data.top_campaigns || [],
//         });

//       } catch (err) {
//         console.error("Ошибка загрузки дашборда:", err);

//         if (err.response?.status === 403) {
//           setSubscriptionError({
//             message: err.response.data?.message || "Дашборд доступен только на тарифе Premium"
//           });
//         } else if (err.response?.status === 401) {
//           navigate('/login');
//         } else {
//           setSubscriptionError({
//             message: "Не удалось загрузить данные. Попробуйте позже."
//           });
//         }
//       } finally {
//         setLoading(false);
//       }
//     }

//     loadDashboard();
//   }, [navigate]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
//       </div>
//     );
//   }

//   // ===== ЗАГЛУШКА «НУЖНА ПОДПИСКА» =====
//   if (subscriptionError) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 md:p-6">
//         <div className="bg-white rounded-2xl shadow-md p-6 md:p-10 max-w-lg w-full text-center">
//           <div className="text-5xl md:text-6xl mb-4">🔒</div>
//           <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
//             Дашборд доступен на платных тарифах
//           </h1>
//           <p className="text-gray-500 mb-6 text-sm md:text-base">
//             {subscriptionError.message}
//           </p>

//           <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-left">
//             <div className="text-sm text-blue-900 font-medium mb-2">
//               Что даёт подписка:
//             </div>
//             <ul className="text-sm text-blue-800 space-y-1">
//               <li>✓ Полная статистика по кампаниям</li>
//               <li>✓ Графики отправок по дням</li>
//               <li>✓ Аналитика по SMTP-аккаунтам</li>
//               <li>✓ Статистика переписок</li>
//             </ul>
//           </div>

//           <button
//             onClick={() => navigate('/pricing')}
//             className="w-full px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition font-medium"
//           >
//             Перейти к тарифам →
//           </button>

//           <button
//             onClick={() => navigate('/smtp')}
//             className="w-full mt-3 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition"
//           >
//             Вернуться к работе
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-6">
//       {/* ===== ЗАГОЛОВОК ===== */}
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4 md:mb-6">
//         <div>
//           <h1 className="text-xl md:text-3xl font-bold text-gray-800">📊 Дашборд</h1>
//           <p className="text-gray-500 mt-1 text-xs md:text-sm">Общая статистика по кампаниям</p>
//         </div>
//         <div className="flex items-center gap-2 flex-wrap">
//           <span className="text-xs md:text-sm text-gray-500">
//             Обновлено: {new Date().toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
//           </span>
//           <button
//             onClick={() => window.location.reload()}
//             className="px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
//           >
//             🔄
//           </button>
//         </div>
//       </div>

//       {/* ===== ЛИМИТЫ ===== */}
//       <LimitsWidget />

//       {/* ===== ВЕРХНИЕ КАРТОЧКИ ===== */}
//       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mb-4 md:mb-6">
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-blue-500">
//           <div className="text-xs md:text-sm text-gray-500">Кампаний</div>
//           <div className="text-2xl md:text-3xl font-bold text-gray-800">{stats.totalCampaigns}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Активных: {stats.activeCampaigns}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-green-500">
//           <div className="text-xs md:text-sm text-gray-500">Отправлено</div>
//           <div className="text-2xl md:text-3xl font-bold text-green-600">{stats.totalSent}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Сегодня: {stats.todaySent}
//           </div>
//         </div>

//         {/* ===== ОТКРЫТИЯ ===== */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-cyan-500">
//           <div className="text-xs md:text-sm text-gray-500">📬 Открыто</div>
//           <div className="text-2xl md:text-3xl font-bold text-cyan-600">
//             {stats.tracking?.opened || 0}
//           </div>
//           <div className="text-xs text-gray-400 mt-1">
//             {stats.tracking?.open_rate || 0}% · сегодня: {stats.tracking?.opened_today || 0}
//           </div>
//         </div>

//         {/* ===== КЛИКИ ===== */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-emerald-500">
//           <div className="text-xs md:text-sm text-gray-500">🖱️ Кликов</div>
//           <div className="text-2xl md:text-3xl font-bold text-emerald-600">
//             {stats.tracking?.clicked || 0}
//           </div>
//           <div className="text-xs text-gray-400 mt-1">
//             всего: {stats.tracking?.total_clicks || 0}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-yellow-500">
//           <div className="text-xs md:text-sm text-gray-500">Контактов</div>
//           <div className="text-2xl md:text-3xl font-bold text-yellow-600">{stats.totalContacts}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Ошибок: {stats.totalFailed}
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-purple-500">
//           <div className="text-xs md:text-sm text-gray-500">Сообщений</div>
//           <div className="text-2xl md:text-3xl font-bold text-purple-600">{stats.totalMessages}</div>
//           <div className="text-xs text-gray-400 mt-1">
//             Сегодня: {stats.messagesToday}
//           </div>
//         </div>
//       </div>

//       {/* ===== ГРАФИКИ ===== */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
//         {/* График отправок */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📈 Отправки по дням</h2>
//           <div className="h-48 md:h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={stats.dailyStats} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="date" tick={{ fontSize: 10 }} />
//                 <YAxis tick={{ fontSize: 10 }} />
//                 <Tooltip contentStyle={{ fontSize: 12 }} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Line type="monotone" dataKey="sent" stroke="#22c55e" name="Отправлено" strokeWidth={2} dot={{ r: 2 }} />
//                 <Line type="monotone" dataKey="failed" stroke="#ef4444" name="Ошибок" strokeWidth={2} dot={{ r: 2 }} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Круговая диаграмма */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📊 Статусы кампаний</h2>
//           <div className="h-48 md:h-64 flex items-center justify-center">
//             {stats.campaignStatusData.length > 0 ? (
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={stats.campaignStatusData}
//                     cx="50%"
//                     cy="50%"
//                     innerRadius={40}
//                     outerRadius={70}
//                     paddingAngle={2}
//                     dataKey="value"
//                     label={({ value }) => value}
//                     labelLine={false}
//                   >
//                     {stats.campaignStatusData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={entry.color} />
//                     ))}
//                   </Pie>
//                   <Tooltip contentStyle={{ fontSize: 12 }} />
//                   <Legend wrapperStyle={{ fontSize: 11 }} />
//                 </PieChart>
//               </ResponsiveContainer>
//             ) : (
//               <div className="text-gray-400 text-sm">Нет данных о кампаниях</div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ===== АКТИВНОСТЬ SMTP + ПОСЛЕДНИЕ ===== */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">📧 Активность SMTP</h2>
//           <div className="h-48 md:h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={stats.smtpPerformance} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" tick={{ fontSize: 10 }} />
//                 <YAxis tick={{ fontSize: 10 }} />
//                 <Tooltip contentStyle={{ fontSize: 12 }} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Bar dataKey="sent" fill="#22c55e" name="Отправлено" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* ===== ПОСЛЕДНИЕ КАМПАНИИ ===== */}
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//           <h2 className="text-base md:text-lg font-semibold mb-3">🔄 Последние кампании</h2>
//           <div className="space-y-2 max-h-56 md:max-h-64 overflow-y-auto">
//             {stats.recentCampaigns.length > 0 ? (
//               stats.recentCampaigns.map((item) => (
//                 <div key={item.id} className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition">
//                   <div className="min-w-0 flex-1">
//                     <div className="font-medium text-gray-800 text-sm truncate">{item.name}</div>
//                     <div className="text-xs text-gray-400">
//                       {new Date(item.created_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
//                     </div>
//                   </div>
//                   <div className="flex items-center gap-2 flex-wrap">
//                     <span className="text-xs md:text-sm text-gray-600">
//                       {item.sent}/{item.total}
//                     </span>
//                     <span className={`px-2 py-0.5 text-[10px] md:text-xs rounded-full whitespace-nowrap ${
//                       item.status === "running" ? "bg-green-100 text-green-700" :
//                       item.status === "completed" ? "bg-blue-100 text-blue-700" :
//                       item.status === "paused" ? "bg-yellow-100 text-yellow-700" :
//                       "bg-red-100 text-red-700"
//                     }`}>
//                       {item.status === "running" ? "▶️ Выполняется" :
//                        item.status === "completed" ? "✅ Завершена" :
//                        item.status === "paused" ? "⏸️ На паузе" :
//                        "⏹️ Остановлена"}
//                     </span>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="text-gray-400 text-center py-8 text-sm">Нет кампаний</div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ===== ТОП-5 КАМПАНИЙ ПО ОТКРЫТИЯМ ===== */}
//       {stats.top_campaigns?.length > 0 && (
//         <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 mt-4 md:mt-6">
//           <h2 className="text-base md:text-lg font-semibold mb-3">
//             📈 Топ-5 кампаний по открытиям
//           </h2>
//           <div className="space-y-2">
//             {stats.top_campaigns.map((c, i) => (
//               <div
//                 key={c.id}
//                 className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition"
//               >
//                 <div className="min-w-0 flex-1 flex items-start gap-3">
//                   <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
//                     i === 0 ? "bg-yellow-100 text-yellow-700" :
//                     i === 1 ? "bg-gray-200 text-gray-700" :
//                     i === 2 ? "bg-orange-100 text-orange-700" :
//                     "bg-gray-100 text-gray-500"
//                   }`}>
//                     {i + 1}
//                   </div>
//                   <div className="min-w-0">
//                     <div className="font-medium text-gray-800 text-sm truncate">
//                       #{c.id} — {c.name}
//                     </div>
//                     <div className="text-xs text-gray-500 mt-0.5">
//                       {c.sent} отправлено · <span className="text-cyan-600">{c.opened} открыто</span>
//                       {c.clicked > 0 && (
//                         <> · <span className="text-emerald-600">{c.clicked} кликов</span></>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-3 flex-shrink-0">
//                   <div className="text-right">
//                     <div className="text-lg md:text-xl font-bold text-cyan-600">{c.open_rate}%</div>
//                     <div className="text-[10px] text-gray-400">open rate</div>
//                   </div>
//                   <div className="w-24 md:w-32 bg-gray-200 h-2 rounded-full overflow-hidden">
//                     <div
//                       className="h-full bg-cyan-500 transition-all duration-500"
//                       style={{ width: `${c.open_rate}%` }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
} from "recharts";
import LimitsWidget from "./LimitsWidget";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [subscriptionError, setSubscriptionError] = useState(null);
  const [stats, setStats] = useState({
    totalCampaigns: 0, totalSent: 0, totalFailed: 0, totalContacts: 0,
    activeCampaigns: 0, completedCampaigns: 0, pausedCampaigns: 0, stoppedCampaigns: 0,
    todaySent: 0, todayFailed: 0, totalMessages: 0, messagesToday: 0,
    incomingMessages: 0, outgoingMessages: 0,
    recentCampaigns: [], dailyStats: [], campaignStatusData: [], smtpPerformance: [],
    tracking: {
      opened: 0, clicked: 0, replied: 0, leads: 0,
      total_opens: 0, total_clicks: 0,
      open_rate: 0, reply_rate: 0, lead_rate: 0,
      opened_today: 0,
    },
    top_campaigns: [],
  });

  const navigate = useNavigate();
  const COLORS = ['#22c55e', '#eab308', '#3b82f6', '#ef4444'];

  useEffect(() => {
    async function loadDashboard() {
      try {
        setLoading(true);
        setSubscriptionError(null);

        const res = await axios.get(`${API_URL}/api/dashboard`);
        const data = res.data;

        const campaignStatusData = [
          { name: "Активные", value: data.campaigns.active, color: "#22c55e" },
          { name: "На паузе", value: data.campaigns.paused, color: "#eab308" },
          { name: "Завершены", value: data.campaigns.completed, color: "#3b82f6" },
          { name: "Остановлены", value: data.campaigns.stopped, color: "#ef4444" },
        ].filter(item => item.value > 0);

        const smtpPerformance = data.smtp_performance.map(s => ({
          ...s,
          received: Math.floor(Math.random() * 10) + 1,
        }));

        setStats({
          totalCampaigns: data.campaigns.total,
          totalSent: data.campaigns.total_sent,
          totalFailed: data.campaigns.total_failed,
          totalContacts: data.contacts.total,
          activeCampaigns: data.campaigns.active,
          completedCampaigns: data.campaigns.completed,
          pausedCampaigns: data.campaigns.paused,
          stoppedCampaigns: data.campaigns.stopped,
          todaySent: data.today.sent,
          todayFailed: data.today.failed,
          totalMessages: data.messages.total,
          messagesToday: data.messages.today,
          incomingMessages: data.messages.incoming,
          outgoingMessages: data.messages.outgoing,
          recentCampaigns: data.recent_campaigns || [],
          dailyStats: data.daily_stats || [],
          campaignStatusData,
          smtpPerformance,
          tracking: data.tracking || {
            opened: 0, clicked: 0, replied: 0, leads: 0,
            total_opens: 0, total_clicks: 0,
            open_rate: 0, reply_rate: 0, lead_rate: 0,
            opened_today: 0,
          },
          top_campaigns: data.top_campaigns || [],
        });

      } catch (err) {
        console.error("Ошибка загрузки дашборда:", err);

        if (err.response?.status === 403) {
          setSubscriptionError({
            message: err.response.data?.message || "Дашборд доступен только на тарифе Premium"
          });
        } else if (err.response?.status === 401) {
          navigate('/login');
        } else {
          setSubscriptionError({
            message: "Не удалось загрузить данные. Попробуйте позже."
          });
        }
      } finally {
        setLoading(false);
      }
    }

    loadDashboard();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // ===== ЗАГЛУШКА «НУЖНА ПОДПИСКА» =====
  if (subscriptionError) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 md:p-6">
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-10 max-w-lg w-full text-center">
          <div className="text-5xl md:text-6xl mb-4">🔒</div>
          <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
            Дашборд доступен на платных тарифах
          </h1>
          <p className="text-gray-500 mb-6 text-sm md:text-base">
            {subscriptionError.message}
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-left">
            <div className="text-sm text-blue-900 font-medium mb-2">
              Что даёт подписка:
            </div>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>✓ Полная статистика по кампаниям</li>
              <li>✓ Графики отправок по дням</li>
              <li>✓ Аналитика по SMTP-аккаунтам</li>
              <li>✓ Статистика переписок</li>
            </ul>
          </div>

          <button
            onClick={() => navigate('/pricing')}
            className="w-full px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition font-medium"
          >
            Перейти к тарифам →
          </button>

          <button
            onClick={() => navigate('/smtp')}
            className="w-full mt-3 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition"
          >
            Вернуться к работе
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-6">
      {/* ===== ЗАГОЛОВОК ===== */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4 md:mb-6">
        <div>
          <h1 className="text-xl md:text-3xl font-bold text-gray-800">📊 Дашборд</h1>
          <p className="text-gray-500 mt-1 text-xs md:text-sm">Общая статистика по кампаниям</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs md:text-sm text-gray-500">
            Обновлено: {new Date().toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
          </span>
          <button
            onClick={() => window.location.reload()}
            className="px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            🔄
          </button>
        </div>
      </div>

      {/* ===== ЛИМИТЫ ===== */}
      <LimitsWidget />

      {/* ===== ВЕРХНИЕ КАРТОЧКИ ===== */}
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-blue-500">
          <div className="text-xs md:text-sm text-gray-500">Кампаний</div>
          <div className="text-2xl md:text-3xl font-bold text-gray-800">{stats.totalCampaigns}</div>
          <div className="text-xs text-gray-400 mt-1">
            Активных: {stats.activeCampaigns}
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-green-500">
          <div className="text-xs md:text-sm text-gray-500">Отправлено</div>
          <div className="text-2xl md:text-3xl font-bold text-green-600">{stats.totalSent}</div>
          <div className="text-xs text-gray-400 mt-1">
            Сегодня: {stats.todaySent}
          </div>
        </div>

        {/* ===== ОТКРЫТИЯ ===== */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-cyan-500">
          <div className="text-xs md:text-sm text-gray-500">📬 Открыто</div>
          <div className="text-2xl md:text-3xl font-bold text-cyan-600">
            {stats.tracking?.opened || 0}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {stats.tracking?.open_rate || 0}% · сегодня: {stats.tracking?.opened_today || 0}
          </div>
        </div>

        {/* ===== КЛИКИ ===== */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-emerald-500">
          <div className="text-xs md:text-sm text-gray-500">🖱️ Кликов</div>
          <div className="text-2xl md:text-3xl font-bold text-emerald-600">
            {stats.tracking?.clicked || 0}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            всего: {stats.tracking?.total_clicks || 0}
          </div>
        </div>

        {/* ===== ОТВЕТЫ ===== */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-teal-500">
          <div className="text-xs md:text-sm text-gray-500">💬 Ответили</div>
          <div className="text-2xl md:text-3xl font-bold text-teal-600">
            {stats.tracking?.replied || 0}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {stats.tracking?.reply_rate || 0}% от отправленных
          </div>
        </div>

        {/* ===== ЛИДЫ ===== */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-indigo-500">
          <div className="text-xs md:text-sm text-gray-500">🎯 Лидов</div>
          <div className="text-2xl md:text-3xl font-bold text-indigo-600">
            {stats.tracking?.leads || 0}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {stats.tracking?.lead_rate || 0}% от отправленных
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-yellow-500">
          <div className="text-xs md:text-sm text-gray-500">Контактов</div>
          <div className="text-2xl md:text-3xl font-bold text-yellow-600">{stats.totalContacts}</div>
          <div className="text-xs text-gray-400 mt-1">
            Ошибок: {stats.totalFailed}
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 border-l-4 border-purple-500">
          <div className="text-xs md:text-sm text-gray-500">Сообщений</div>
          <div className="text-2xl md:text-3xl font-bold text-purple-600">{stats.totalMessages}</div>
          <div className="text-xs text-gray-400 mt-1">
            Сегодня: {stats.messagesToday}
          </div>
        </div>
      </div>

      {/* ===== ГРАФИКИ ===== */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
        {/* График отправок */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
          <h2 className="text-base md:text-lg font-semibold mb-3">📈 Отправки по дням</h2>
          <div className="h-48 md:h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={stats.dailyStats} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                <YAxis tick={{ fontSize: 10 }} />
                <Tooltip contentStyle={{ fontSize: 12 }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Line type="monotone" dataKey="sent" stroke="#22c55e" name="Отправлено" strokeWidth={2} dot={{ r: 2 }} />
                <Line type="monotone" dataKey="failed" stroke="#ef4444" name="Ошибок" strokeWidth={2} dot={{ r: 2 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Круговая диаграмма */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
          <h2 className="text-base md:text-lg font-semibold mb-3">📊 Статусы кампаний</h2>
          <div className="h-48 md:h-64 flex items-center justify-center">
            {stats.campaignStatusData.length > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={stats.campaignStatusData}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={70}
                    paddingAngle={2}
                    dataKey="value"
                    label={({ value }) => value}
                    labelLine={false}
                  >
                    {stats.campaignStatusData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip contentStyle={{ fontSize: 12 }} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-gray-400 text-sm">Нет данных о кампаниях</div>
            )}
          </div>
        </div>
      </div>

      {/* ===== ВОРОНКА КОНВЕРСИИ ===== */}
      {(stats.totalSent > 0) && (
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-2xl p-3 md:p-5 mb-4 md:mb-6">
          <h2 className="text-base md:text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
            🎯 Общая воронка конверсии
          </h2>

          <div className="space-y-3">
            {/* Отправлено */}
            <div>
              <div className="flex justify-between text-xs md:text-sm mb-1">
                <span className="text-gray-700 font-medium">📨 Отправлено</span>
                <span className="font-bold text-gray-800">
                  {stats.totalSent}
                  <span className="text-gray-400 font-normal ml-2">100%</span>
                </span>
              </div>
              <div className="w-full bg-white rounded-full h-2.5 overflow-hidden">
                <div className="h-full bg-gray-400" style={{ width: "100%" }} />
              </div>
            </div>

            {/* Открыто */}
            <div>
              <div className="flex justify-between text-xs md:text-sm mb-1">
                <span className="text-gray-700 font-medium">📬 Открыто</span>
                <span className="font-bold text-cyan-700">
                  {stats.tracking?.opened || 0}
                  <span className="text-gray-400 font-normal ml-2">
                    {stats.tracking?.open_rate || 0}%
                  </span>
                </span>
              </div>
              <div className="w-full bg-white rounded-full h-2.5 overflow-hidden">
                <div
                  className="h-full bg-cyan-500 transition-all duration-500"
                  style={{ width: `${stats.tracking?.open_rate || 0}%` }}
                />
              </div>
            </div>

            {/* Ответили */}
            <div>
              <div className="flex justify-between text-xs md:text-sm mb-1">
                <span className="text-gray-700 font-medium">💬 Ответили</span>
                <span className="font-bold text-teal-700">
                  {stats.tracking?.replied || 0}
                  <span className="text-gray-400 font-normal ml-2">
                    {stats.tracking?.reply_rate || 0}%
                  </span>
                </span>
              </div>
              <div className="w-full bg-white rounded-full h-2.5 overflow-hidden">
                <div
                  className="h-full bg-teal-500 transition-all duration-500"
                  style={{ width: `${stats.tracking?.reply_rate || 0}%` }}
                />
              </div>
            </div>

            {/* Лиды */}
            <div>
              <div className="flex justify-between text-xs md:text-sm mb-1">
                <span className="text-gray-700 font-medium">🎯 Стали лидами</span>
                <span className="font-bold text-indigo-700">
                  {stats.tracking?.leads || 0}
                  <span className="text-gray-400 font-normal ml-2">
                    {stats.tracking?.lead_rate || 0}%
                  </span>
                </span>
              </div>
              <div className="w-full bg-white rounded-full h-2.5 overflow-hidden">
                <div
                  className="h-full bg-indigo-500 transition-all duration-500"
                  style={{ width: `${stats.tracking?.lead_rate || 0}%` }}
                />
              </div>
            </div>
          </div>

          {/* Итоговая конверсия */}
          <div className="mt-4 pt-4 border-t border-blue-200 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
            <div className="text-xs md:text-sm text-gray-600">
              Итоговая конверсия: <b>{stats.totalSent}</b> отправлено → <b>{stats.tracking?.leads || 0}</b> лидов
            </div>
            <div className="flex items-baseline gap-2">
              <span className="text-3xl md:text-4xl font-bold text-indigo-700">
                {stats.tracking?.lead_rate || 0}%
              </span>
              <span className="text-xs text-gray-500">общая конверсия</span>
            </div>
          </div>
        </div>
      )}

      {/* ===== АКТИВНОСТЬ SMTP + ПОСЛЕДНИЕ ===== */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
          <h2 className="text-base md:text-lg font-semibold mb-3">📧 Активность SMTP</h2>
          <div className="h-48 md:h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={stats.smtpPerformance} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                <YAxis tick={{ fontSize: 10 }} />
                <Tooltip contentStyle={{ fontSize: 12 }} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="sent" fill="#22c55e" name="Отправлено" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* ===== ПОСЛЕДНИЕ КАМПАНИИ ===== */}
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
          <h2 className="text-base md:text-lg font-semibold mb-3">🔄 Последние кампании</h2>
          <div className="space-y-2 max-h-56 md:max-h-64 overflow-y-auto">
            {stats.recentCampaigns.length > 0 ? (
              stats.recentCampaigns.map((item) => (
                <div key={item.id} className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition">
                  <div className="min-w-0 flex-1">
                    <div className="font-medium text-gray-800 text-sm truncate">{item.name}</div>
                    <div className="text-xs text-gray-400">
                      {new Date(item.created_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs md:text-sm text-gray-600">
                      {item.sent}/{item.total}
                    </span>
                    <span className={`px-2 py-0.5 text-[10px] md:text-xs rounded-full whitespace-nowrap ${
                      item.status === "running" ? "bg-green-100 text-green-700" :
                      item.status === "completed" ? "bg-blue-100 text-blue-700" :
                      item.status === "paused" ? "bg-yellow-100 text-yellow-700" :
                      "bg-red-100 text-red-700"
                    }`}>
                      {item.status === "running" ? "▶️ Выполняется" :
                       item.status === "completed" ? "✅ Завершена" :
                       item.status === "paused" ? "⏸️ На паузе" :
                       "⏹️ Остановлена"}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-gray-400 text-center py-8 text-sm">Нет кампаний</div>
            )}
          </div>
        </div>
      </div>

      {/* ===== ТОП-5 КАМПАНИЙ ПО ОТКРЫТИЯМ ===== */}
      {stats.top_campaigns?.length > 0 && (
        <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 mt-4 md:mt-6">
          <h2 className="text-base md:text-lg font-semibold mb-3">
            📈 Топ-5 кампаний по открытиям
          </h2>
          <div className="space-y-2">
            {stats.top_campaigns.map((c, i) => (
              <div
                key={c.id}
                className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition"
              >
                <div className="min-w-0 flex-1 flex items-start gap-3">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                    i === 0 ? "bg-yellow-100 text-yellow-700" :
                    i === 1 ? "bg-gray-200 text-gray-700" :
                    i === 2 ? "bg-orange-100 text-orange-700" :
                    "bg-gray-100 text-gray-500"
                  }`}>
                    {i + 1}
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium text-gray-800 text-sm truncate">
                      #{c.id} — {c.name}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5 flex flex-wrap gap-x-2">
                      <span>{c.sent} отправлено</span>
                      <span className="text-cyan-600">· {c.opened} открыто</span>
                      {c.clicked > 0 && <span className="text-emerald-600">· {c.clicked} кликов</span>}
                      {c.replied > 0 && <span className="text-teal-600">· {c.replied} ответов</span>}
                      {c.leads > 0 && <span className="text-indigo-600">· {c.leads} лидов</span>}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-lg md:text-xl font-bold text-cyan-600">{c.open_rate}%</div>
                    <div className="text-[10px] text-gray-400">open rate</div>
                  </div>
                  <div className="w-24 md:w-32 bg-gray-200 h-2 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-cyan-500 transition-all duration-500"
                      style={{ width: `${c.open_rate}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}